import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class EventoService {
  constructor(private http: HttpClient) {}

  getMyEvents(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    return this.http.post<any>(
      environment.urlEvento + "?opcion=1",
      formData,
      options
    );
  }

  createEvents(id, auth_key, data) {
    console.log(data);

    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("Evento[id_user]", id);
    formData.append("Evento[titulo]", data.title);
    formData.append("Evento[descripcion]", data.desc);
    formData.append("Evento[hora_inicio]", data.startTime);
    formData.append("Evento[hora_fin]", data.endTime);
    formData.append("Evento[allDay]", data.allDay ? "1" : "0");
    return this.http.post<any>(
      environment.urlEvento + "?opcion=2",
      formData,
      options
    );
  }

  createEventActivity(id, auth_key, data) {
    console.log("data", data);

    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("FechaEntregaActividad[id_curso]", data.id_curso);

    if (data.id_libro != null)
      formData.append("FechaEntregaActividad[id_libro]", data.id_libro);

    if (data.id_actividad != null)
      formData.append("FechaEntregaActividad[id_actividad]", data.id_actividad);

    formData.append("FechaEntregaActividad[titulo]", data.titulo);
    formData.append("FechaEntregaActividad[hora_inicio]", data.hora_inicio);
    formData.append("FechaEntregaActividad[hora_fin]", data.hora_fin);
    return this.http.post<any>(
      environment.urlEvento + "?opcion=3",
      formData,
      options
    );
  }

  getActivityId(id, auth_key, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("FechaEntregaActividad[id_curso]", data.id_curso);
    formData.append("FechaEntregaActividad[id_libro]", data.id_libro);
    formData.append("FechaEntregaActividad[id_actividad]", data.id_actividad);
    return this.http.post<any>(
      environment.urlEvento + "?opcion=5",
      formData,
      options
    );
  }

  updateEventActivity(id, auth_key, data) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("ActividadesFechahoraentrega[id]", data.id);
    formData.append("ActividadesFechahoraentrega[fecha_hora]", data.fecha_hora);
    formData.append("ActividadesFechahoraentrega[fecha_fin]", data.fecha_fin);
    return this.http.post<any>(
      environment.urlEvento + "?opcion=6",
      formData,
      options
    );
  }

  getMyActivities(id, auth_key) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    return this.http.post<any>(
      environment.urlEvento + "?opcion=4",
      formData,
      options
    );
  }

  deleteEventActivity(id, auth_key, id_evento) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("auth_key", auth_key);
    formData.append("id_user", id);
    formData.append("id_evento", id_evento);
    return this.http.post<any>(
      environment.urlEvento + "?opcion=7",
      formData,
      options
    );
  }
}
